// extracted by mini-css-extract-plugin
export default {"show_sort_basis":"showSortBasis_show_sort_basis__iUxel","sort":"showSortBasis_sort__FFawV"};